import UtmGenerator from './../modules/utm_generator/utm_generator'

new UtmGenerator();
